import React from 'react';
import Select, { GroupBase, Props, StylesConfig } from 'react-select';
// @ts-expect-error: Can't find module
// eslint-disable-next-line import/no-unresolved
import { SelectComponentsConfig } from 'react-select/dist/declarations/src/components';

import { Box, Icon } from '@opendoor/bricks/core';

import { InputContainerElement } from './Input';

// https://github.com/JedWatson/react-select/blob/b53e64754493479cd5506879392d4e3e726025c5/packages/react-select/src/Select.tsx#L74
type SelectProps = Omit<Props, 'isSearchable' | 'options'>;

export type ComboInputOption = {
  label: string;
  value: string;
  data?: unknown;
};

export type ComboInputElementProps = {
  id: string;
  options: Array<ComboInputOption>;
} & SelectProps;

const comboInputComponents: SelectComponentsConfig<
  ComboInputOption,
  false,
  GroupBase<ComboInputOption>
> = {
  DropdownIndicator: () => <Icon color="inherit" name="chevron-down" size={24} />,
  IndicatorSeparator: () => null,
};

const comboInputStyles: StylesConfig<ComboInputOption> = {
  container: (baseStyles, _) => ({
    ...baseStyles,
    width: '100%',
    left: 0,
  }),
  input: (baseStyles, _) => ({
    ...baseStyles,
    padding: 0,
    margin: 0,
  }),
  control: (baseStyles, _) => ({
    ...baseStyles,
    border: 'none',
    boxShadow: 'none',
    borderColor: 'none',
    background: 'transparent',
    padding: '28px 22px',
    margin: 0,
  }),
  menu: (baseStyles, _) => ({
    ...baseStyles,
    border: '2px solid #000',
    borderRadius: '24px',
    top: '86px',
    overflow: 'hidden',
  }),
  menuList: (baseStyles, _) => ({
    ...baseStyles,
    display: 'Flex',
    flexDirection: 'column',
    gap: '4px',
    // gap: '8px', -- TODO too big for mobile?
    padding: '8px',
  }),
  option: (baseStyles, props) => ({
    ...baseStyles,
    borderRadius: '16px',
    backgroundColor: props.isFocused ? '#F2F1F0' : 'white',
    padding: '14px',

    color: '#706F6E',
    /* 140 Reg */
    fontFamily: 'Graphik',
    // fontSize: '22px', -- TODO seems to big for mobile
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '112%' /* 24.64px */,
    letterSpacing: '-0.528px',
  }),
  indicatorsContainer: (baseStyles, state) => ({
    ...baseStyles,
    marginRight: '20px',
    transform: state.selectProps.menuIsOpen ? 'rotateX(180deg)' : undefined,
  }),
  clearIndicator: (baseStyles, _state) => ({
    ...baseStyles,
    padding: '2px',
  }),
  valueContainer: (baseStyles, _) => ({
    ...baseStyles,
    padding: 0,
  }),
};

/*
  Component which wraps React-Select

  Its intended to be used for dropdown input that can search and select.
  SelectProps allows any prop defined by react-select to be passed in. 
*/
export const ComboInputElement: React.FC<ComboInputElementProps> = ({
  id,
  placeholder,
  options = [],
  isLoading = false,
  name,
  ...selectProps
}) => {
  return (
    <Box position={['relative']}>
      <InputContainerElement style={{ padding: '0', position: 'relative' }}>
        {/** @ts-expect-error: isMulti weirdness */}
        <Select<ComboInputOption>
          inputId={id}
          name={name}
          className="Select-input"
          components={comboInputComponents}
          styles={comboInputStyles}
          options={options}
          placeholder={placeholder}
          // menuIsOpen={true} // used for debugging
          isSearchable
          isLoading={isLoading}
          {...selectProps}
        />
      </InputContainerElement>
    </Box>
  );
};
